import { IAddressBase } from '../../models/address';
import { IUserBase, UserGender } from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateUserProps {
  address?: IAddressBase;
  bio?: string;
  birthDate?: Date;
  categoryId?: string;
  cpf?: string;
  cnpj?: string;
  companyName?: string;
  email: string;
  experience?: number;
  featureGroupId?: string;
  featureGroupKey?: string;
  gender?: UserGender;
  healthCheck?: Date;
  hostId?: string;
  name: string;
  foreignerDocument?: string;
  foreignerDocumentType?: string;
  useForeignerDocument?: boolean;
  phone?: string;
  tradeName?: string;
  ventureId?: string | null;
}

export type INewUser = IUserBase;

export const createUsersService = async ({
  address,
  bio,
  birthDate,
  categoryId,
  cpf,
  cnpj,
  companyName,
  email,
  experience,
  featureGroupId,
  featureGroupKey,
  gender,
  healthCheck,
  hostId,
  name,
  foreignerDocument,
  foreignerDocumentType,
  useForeignerDocument,
  phone,
  tradeName,
  ventureId,
}: ICreateUserProps): Promise<INewUser> => {
  const { data } = await jhsfBookingsApi.post<INewUser>('/users', {
    address,
    bio,
    birthDate,
    categoryId,
    cpf,
    cnpj,
    companyName,
    email,
    experience,
    featureGroupId,
    featureGroupKey,
    gender,
    healthCheck,
    hostId,
    name,
    foreignerDocument,
    foreignerDocumentType,
    useForeignerDocument,
    phone,
    tradeName,
    ventureId,
  });

  return data;
};
